export default __webpack_public_path__ + "static/media/ic_edit.0b207a97.svg";